import React from 'react';

export const Heart = ({ strokeColor = 'black', transform }) => (
  <g transform={transform}>
    <path
      fill={'none'}
      stroke={strokeColor}
      strokeWidth={1}
      d='M50.002,20.532C29.919-3.799-12.5,21.679,12.851,57.393c10.002,14.08,37.151,31.672,37.151,31.672  c0.013-0.01,27.145-17.592,37.147-31.672C112.5,21.679,70.081-3.799,50.002,20.532z' />
  </g>
);

export const Munch = ({ strokeColor = 'black', transform }) => (
  <g transform={transform}>
    <g>
      <path id='lip-top' d={`
      M 20 50
      C 20 70, 80 70, 80 50
      `} stroke={strokeColor} strokeLinecap='round' strokeWidth={2} fill={'none'} />
      <path id='lip-bottom' d={`
        M 20 50
        C 20 60, 80 60, 80 50
        `} stroke={strokeColor} strokeLinecap='round' strokeWidth={2} fill={'none'} />
      <path id='mouth-closed' d={`
        M 20 50
        C 20 60, 80 65, 80 50
        `} stroke={'none'} fill={'none'} />
      <path id='cheek-left' d={`
        M 20 45
        q 0 12, -4 15
        `} stroke={strokeColor} strokeLinecap='round' strokeWidth={2} fill={'none'} />
      <path id='cheek-left-a' d={`
        M 20 40
        q 2 12, -8 20
        `} stroke={'none'} strokeLinecap='round' strokeWidth={2} fill={'none'} />
      <path id='cheek-right' d={`
        M 80 45
        q 0 12, 4 15
        `} stroke={strokeColor} strokeLinecap='round' strokeWidth={2} fill={'none'} />
      <path id='cheek-right-a' d={`
        M 80 40
        q -2 12, 8 20
        `} stroke={'none'} fill={'none'} />
    </g>
    <g>
      <path id='motion-path-1' d={`
        M 90 100
        q 0 -30 -40 -40
      `} stroke='none' fill='none' />
      <path id='motion-path-2' d={`
        M 10 100
        q 0 -30 40 -40
      `} stroke='none' fill='none' />
    </g>
  </g>
  );

export const Podium = ({ transform, strokeColor = 'white', fill = 'black', nodeColors = ['black', 'black', 'black'] }) => (
  <g transform={transform}>
    <g>
      <path id='podium-rect-1' d={`
        M 0 71
        q 0 -5, 5 -5
        c 3 0, 6 0, 9 0
        c 3 0, 6 0, 9 0
        q 5 0,5 5 v 29 h -28 Z
        `} fill={fill} />
      <path id='podium-rect-1a' d={`
        M 0 71
        q 0 -5, 5 -5
        c 3 0, 6 3, 9 3
        c 3 0, 6 -3, 9 -3
        q 5 0,5 5 v 29 h -28 Z
        `} fill={'none'} />
      <path id='podium-rect-2' d={`
        M 36 65
        q 0 -5, 5 -5
        c 3 0, 6 0, 9 0
        c 3 0, 6 0, 9 0
        q 5 0,5 5
        v 35 h -28 Z
      `} fill={fill} />
      <path id='podium-rect-2a' d={`
        M 36 65
        q 0 -5, 5 -5
        c 3 0, 6 3, 9 3
        c 3 0, 6 -3, 9 -3
        q 5 0,5 5
        v 35 h -28 Z
      `} fill={'none'} />
      <path id='podium-rect-3' d={`
        M 72 81
        q 0 -5, 5 -5
        c 3 0, 6 0, 9 0
        c 3 0, 6 0, 9 0
        q 5 0,5 5
        v 29 h -28 Z
      `} fill={fill} />
      <path id='podium-rect-3a' d={`
        M 72 81
        q 0 -5, 5 -5
        c 3 0, 6 3, 9 3
        c 3 0, 6 -3, 9 -3
        q 5 0,5 5
        v 29 h -28 Z
      `} fill={'none'} />
    </g>
    <g>
      <circle id='podium-circle-1' stroke={strokeColor} strokeWidth={1} fill={nodeColors[0]} r={8} cx={14} cy={56} />
      <circle id='podium-circle-2' stroke={strokeColor} strokeWidth={1} fill={nodeColors[1]} r={10} cx={50} cy={50} />
      <circle id='podium-circle-3' stroke={strokeColor} strokeWidth={1} fill={nodeColors[2]} r={7} cx={86} cy={66} />
    </g>
  </g>
);
export const Flask = ({ transform, liquidColor = 'black', flaskColor = 'black' }) => (
  <g transform={transform}>
    <path id='liquid-1' d='M 67.771 67.945
      L 57.605 53.427
      C 55,58 45,48 42.395 53.427
      L 32.229 67.945
      c 0 0 -2.762 3.762 2.562 3.762
      c 5.604 0 15.209 0 15.209 0
      s 9.604 0 15.209 0
      C 70.532 71.707 67.771 67.945 67.771 67.945
      z' fill={liquidColor} />
    <path id='liquid-2' d='M 67.771 67.945
      L 57.605 53.427
      C 55,48 45,58 42.395 53.427
      L 32.229 67.945
      c 0 0 -2.762 3.762 2.562 3.762
      c 5.604 0 15.209 0 15.209 0
      s 9.604 0 15.209 0
      C 70.532 71.707 67.771 67.945 67.771 67.945
      z' fill='none' />
    <path d='M69,75H31.002c-2,0-3.29-0.557-3.835-1.656c-1.115-2.252,1.473-5.755,1.771-6.146L44.17,45.012V25.5h1v19.822    L29.748,67.783c-0.721,0.949-2.398,3.677-1.685,5.118C28.426,73.63,29.414,74,31.002,74H69c1.588,0,2.576-0.37,2.938-1.099    c0.714-1.441-0.964-4.169-1.67-5.099l-15.437-22.48V25.5h1v19.512l15.246,22.205c0.284,0.372,2.872,3.875,1.757,6.127    C72.29,74.443,71,75,69,75z' fill={flaskColor} />
  </g>
);



// WEBPACK FOOTER //
// ./src/components/AnimatedIcons/IconPaths.jsx